import React from 'react';

const Badge = React.forwardRef(({ className, variant = "default", ...props }, ref) => {
  const variants = {
    default: "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300",
    primary: "bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300",
    secondary: "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300",
    destructive: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300",
    outline: "border border-gray-300 bg-transparent text-gray-700 dark:border-gray-600 dark:text-gray-300",
    success: "bg-good/15 text-good-strong dark:text-good",
    // Warm terracotta (a category accent) — deliberately NOT alarm-yellow; the
    // app has no yellow tier. Used for e.g. mental-health category tags.
    warning: "bg-[#F3D9CF] text-[#9A4A34] dark:bg-[#3A241C] dark:text-[#E0A48F]",
  };

  return (
    <div
      ref={ref}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${variants[variant]} ${className || ''}`}
      {...props}
    />
  );
});

Badge.displayName = "Badge";

export { Badge };
